import Vuex from 'vuex';
import Vue from 'vue';
import { gameBoardState }  from './modules/gameBoard';
import { playersState } from './modules/players';
import { wordPackState } from './modules/wordPack';
import { newGameButtonState } from './modules/newGame';
import { spyMasterState } from './modules/spyMasterToggle';
import ipfsRoomP2PPlugin from './plugins/ipfsRoomP2PPlugin';
import room from "../room";
const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

// TODO make plugin for state to recieve actions from its peers in the game room.

export default new Vuex.Store({
    modules: {
      gameBoardState,
      playersState,
      wordPackState,
      newGameButtonState,
      spyMasterState
    },
    strict: debug,
    plugins: [ipfsRoomP2PPlugin(room)]
});
